<div class="devo-donors-contacts-view-part">

	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="contacts()"></grid-content>

</div>